import { render, staticRenderFns } from "./KPIScore.vue?vue&type=template&id=6f392b2c&scoped=true&"
import script from "./KPIScore.vue?vue&type=script&lang=js&"
export * from "./KPIScore.vue?vue&type=script&lang=js&"
import style0 from "./KPIScore.vue?vue&type=style&index=0&id=6f392b2c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f392b2c",
  null
  
)

export default component.exports